var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircularAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F5F7F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8334 19.1667H20.8334V14.1667C20.8334 13.7059 20.46 13.3334 20 13.3334C19.54 13.3334 19.1667 13.7059 19.1667 14.1667V19.1667H14.1667C13.7067 19.1667 13.3334 19.5392 13.3334 20C13.3334 20.4609 13.7067 20.8334 14.1667 20.8334H19.1667V25.8334C19.1667 26.2942 19.54 26.6667 20 26.6667C20.46 26.6667 20.8334 26.2942 20.8334 25.8334V20.8334H25.8334C26.2934 20.8334 26.6667 20.4609 26.6667 20C26.6667 19.5392 26.2934 19.1667 25.8334 19.1667Z",
    fill: "#668598"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularAdd);
export default __webpack_public_path__ + "static/media/CircularAdd.02a7f84f.svg";
export { ForwardRef as ReactComponent };